
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/gold-loans/gold-loan-from-home-application-process",
      function () {
        return require("private-next-pages/help/gold-loans/gold-loan-from-home-application-process.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/gold-loans/gold-loan-from-home-application-process"])
      });
    }
  